<div class="page gray-font-color font-family bodyBackground birth-location">
  @if (errorMessage) {
    <mat-error class="error padding-left-md">
      {{ errorMessage }}
    </mat-error>
  }
  <form [formGroup]="birthForm">
    <div class="header-navigation-back">
      <mat-icon (click)="navigateBack()" data-test="back-arrow-icon" data-testid="back-arrow-icon">arrow_back</mat-icon>
      <span class="title">Birth Location</span>
    </div>
    <div class="birth-container" data-test="birth-container" data-testid="birth-container">
      <div>
        <mat-form-field class="full-width" appearance="outline">
          <mat-label>Country Of Birth</mat-label>
          <mat-select
            formControlName="birthCountry"
            (selectionChange)="onCountryChange($event.value)"
            required
            data-test="birth-country"
            data-testid="birth-country"
            >
            <mat-select-trigger>
              @if (birthForm.get('birthCountry')?.value) {
                <span>{{ getSelectedCountryName() }}</span>
              } @else {
                <span class="placeholder-text">Country Of Birth</span>
              }
            </mat-select-trigger>
            <mat-form-field class="dropdown-search full-width" appearance="outline">
              <input
                matInput
                placeholder="Search..."
                (keydown)="$event.stopPropagation()"
                (keyup)="onCertnCountrySearch($event)"
                data-test="search-countries"
                data-testid="search-countries"
                />
            </mat-form-field>
            @for (country of filteredCountries; track country) {
              <mat-option [value]="country.value" data-test="country-name" [attr.data-testid]="'birth-country-' + (country.key | lowercase)">
                {{ country.key }}
              </mat-option>
            }
          </mat-select>
          @if (birthForm.get('birthCountry').touched && birthForm.get('birthCountry').invalid) {
            <mat-error
              data-test="birth-error"
              data-testid="birth-error"
              >
              {{ requiredMessage }}
            </mat-error>
          }
        </mat-form-field>
      </div>
      @if (enableProvinceButton) {
        <div>
          <mat-form-field class="full-width" appearance="outline">
            <mat-label>Birth State/Province</mat-label>
            <mat-select formControlName="birthProvince" required data-test="birth-province" data-testid="birth-province">
              @for (province of stateProvinces; track province) {
                <mat-option [value]="province.value" data-test="province-name" [attr.data-testid]="'birth-province-' + (province.name | lowercase)">
                  {{ province.name }}
                </mat-option>
              }
            </mat-select>
            @if (
              birthForm.get('birthProvince').touched && birthForm.get('birthProvince').invalid && enableProvinceButton
              ) {
              <mat-error
                >
                {{ requiredMessage }}
              </mat-error>
            }
          </mat-form-field>
        </div>
      }
      <div class="btn-container">
        <button
          mat-raised-button
          type="button"
          class="next-button full-width"
          (click)="onSubmit()"
          [disabled]="birthForm.get('birthProvince').invalid || !birthForm.get('birthCountry').value"
          data-test="next-button"
          data-testid="next-button"
          >
          Next
        </button>
      </div>
    </div>
  </form>
</div>
